var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import ActionButton from '@rad/components/ui/action-button';
import Link from '@rad/components/utility/link';
import { toOrgStoryForm } from '../../../../types';
import { updateOrgStory } from '../../../../common/network/org-story';
import { accountRoutes } from '../../../../common/routes';
import { useToast } from '../../../../contexts/toast';
// Who can see a draft; whoever may edit it publishes it, or opens it in the editor, from here.
const DraftNotice = (props) => {
    const toast = useToast();
    const [published, setPublished] = useState(false);
    const publish = () => __awaiter(void 0, void 0, void 0, function* () {
        const [ok] = yield updateOrgStory(Object.assign(Object.assign({}, toOrgStoryForm(props.story)), { 'status': 'published' }));
        if (ok) {
            setPublished(true);
            toast.success('Story published. Visitors can see it now.');
        }
        else
            toast.error('We could not publish this story. Please try again.');
    });
    if (published)
        return _jsx(_Fragment, {});
    return _jsx(_Fragment, { children: _jsxs("div", { className: "property-notice property-notice--warning mb-3", children: [_jsx("i", { className: "bi bi-eye-slash text-warning" }), _jsxs("div", { children: ["This story is a draft. Only members of ", props.orgTitle, " can see it.", props.story.canEdit && !props.contributionSaved && ' Save it in the editor before publishing it.', props.story.canEdit &&
                            _jsxs("div", { className: "d-flex flex-wrap gap-2 mt-2", children: [props.contributionSaved &&
                                        _jsx(ActionButton, { className: "btn btn-sm btn-primary", loadingText: "Publishing\u2026", onClick: publish, children: "Publish story" }), _jsxs(Link, { href: `${accountRoutes.myPropertiesManage.getURL({ 'id': props.story.propertyId })}?story=${props.story.id}`, className: "btn btn-sm btn-outline-secondary", children: [_jsx("i", { className: "bi bi-pencil-square me-1", "aria-hidden": "true" }), "Edit story"] })] })] })] }) });
};
export default DraftNotice;
